<template>
    <section class="a-research">
        <div class="a-research__title-wrap  a-market__title">
            <h2
                v-if="researchData.title"
                class="a-research__title">
                {{ researchData.title }}
            </h2>
            <div class="a-research__links-wrap">
                <div class="a-research__select">
                    <select-date-filter
                        @option-selected="optionSelected"
                        @date-selected="dateSelected"/>
                </div>
                <a
                    v-if="researchData.link"
                    class="a-research__link"
                    :href="researchData.link.href"
                    :title="researchData.link.title">
                    {{ researchData.link.title }}
                </a>
            </div>
        </div>
        <div
            class="a-research__container"
            :class="researchData.full ? 'full' : ''"
            ref="resizeContainer">
            <research-item
                v-if="researchDataItems.data && researchDataItems.data.length !== 0"
                :research-item-data="researchDataItems.data" :use-description="!researchData.disableDescription" />
            <empty-text
                v-else
                :empty-text="emptyText" />
        </div>
        <show-more-btn
            v-if="
                researchDataItems.data &&
                researchDataItems.data.length > 3 &&
                !researchData.full"
            :full-list="researchData.full"
            :desktop-small-device="desktopSmallDevice"
            :desktop-device="desktopDevice"
            :has-mobile-device="mobileDevice"
            :tablet-device="tabletDevice"
            :show-more="showMore"
            @toggleHeight="toggleHeight"/>
    </section>
</template>

<script>
    import ResearchItem from './ResearchItem'
    import ShowMoreBtn from './helpers/ShowMoreBtn'
    import SelectDateFilter from './helpers/SelectDateFilter'
    import EmptyText from './helpers/EmptyText'

    export default {
        name: 'Research',
        props: {
            desktopSmallDevice: Boolean,
            desktopDevice: Boolean,
            tabletDevice: Boolean,
            mobileDevice: Boolean,
            researchData: Object,
            researchDataItems: Object,
        },
        data() {
            return {
                showMore: false,
                resizeHeight: '',
                pageCounter: 1,
                perPage: 6,
                emptyText: 'За данный период ничего не найдено.',
            }
        },
        components: {
            ResearchItem,
            ShowMoreBtn,
            SelectDateFilter,
            EmptyText
        },
        methods: {
            toggleHeight () {
                if (this.researchDataItems.nav.NavPageCount !== this.pageCounter) {
                    this.pageCounter += 1
                    this.$emit('showMorePress', this.pageCounter)
                    this.$refs.resizeContainer.style.height = `${this.$refs.resizeContainer.scrollHeight}px`
                } else {
                    if (this.$refs.resizeContainer.offsetHeight === this.$refs.resizeContainer.scrollHeight) {
                        this.$refs.resizeContainer.style.height = `${this.resizeHeight}px`;
                        this.showMore = false
                        return
                    }
                    this.$refs.resizeContainer.style.height = `${this.$refs.resizeContainer.scrollHeight}px`
                    setTimeout(() => {
                        if (this.$refs.resizeContainer.offsetHeight === this.$refs.resizeContainer.scrollHeight) {
                            this.showMore = true
                        }
                    }, 1000);
                }
            },

            setResizeContainerHeight () {
                this.resizeHeight = this.$refs.resizeContainer.offsetHeight;
                this.$refs.resizeContainer.style.height = `${this.resizeHeight}px`;
            },

            optionSelected (id) {
                this.pageCounter = 1
                this.$emit('optionSelected', id)
                this.$refs.resizeContainer.style.height = `${this.resizeHeight}px`;
                this.showMore = false
            },

            dateSelected (dateStart, dateEnd) {
                this.pageCounter = 1
                this.$emit('dateSelected', dateStart, dateEnd)
                this.$refs.resizeContainer.style.height = `${this.resizeHeight}px`;
                this.showMore = false
            }
        },
        mounted() {
            if (!this.researchData.full) {
                this.setResizeContainerHeight()
            }
        }
    }
</script>